import type { FC, ReactNode } from 'react'

import { useId } from 'react'
import { cn } from '@/lib/utils'
import { siteConfig } from '@/constants/site'

interface LogoMarkProps {
    className?: string
}

export const LogoMark: FC<LogoMarkProps> = ({ className }): ReactNode => {
    const gradientId = `lumawall-mark-${useId().replace(/[^a-zA-Z0-9_-]/g, '')}`

    return (
        <svg
            viewBox='0 0 64 64'
            aria-hidden='true'
            className={cn('size-7 shrink-0', className)}
        >
            <defs>
                <linearGradient id={gradientId} x1='0' y1='0' x2='0' y2='1'>
                    <stop offset='0' stopColor='#7c6cf0' />
                    <stop offset='0.55' stopColor='#f08aa8' />
                    <stop offset='1' stopColor='#f6b65e' />
                </linearGradient>
            </defs>

            <rect x='4' y='4' width='56' height='56' rx='16' fill={`url(#${gradientId})`} />
            <circle cx='32' cy='36' r='10' fill='#fff4dc' opacity='0.95' />
            <path d='M4 44 L22 30 L32 38 L44 28 L60 42 L60 44 C60 52.8 52.8 60 44 60 L20 60 C11.2 60 4 52.8 4 44 Z' fill='#14121c' />
        </svg>
    )
}

interface LogoProps {
    className?: string
}

export const Logo: FC<LogoProps> = ({ className }): ReactNode => {
    return (
        <span className={cn('inline-flex items-center gap-2.5', className)}>
            <LogoMark />

            <span className='text-[1.05rem] font-semibold tracking-tight lowercase'>
                {siteConfig.name}
            </span>
        </span>
    )
}
